export function getRawPrice (discountPrice, discountAmount) {
  if (!discountAmount) {
    return discountPrice
  }
  return (discountPrice * 100) / (100 - discountAmount)
}
